import { ColumnModal } from "@/components";

import { CommunityPostHeader, CommunityPostInput } from "../";
import { PostItem } from "../../types";

interface CommunityPostModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  post?: PostItem;
}

export const CommunityPostModal = ({
  open,
  setOpen,
  post,
}: CommunityPostModalProps) => {
  return (
    <ColumnModal
      cols={4}
      open={open}
      onOpenChange={setOpen}
      hideTrigger
      hideFooter
      closeButtonClassName="top-[36px]"
      maxHeight="85vh"
    >
      <div className="flex flex-col px-6">
        <CommunityPostHeader className="mb-[20px] ml-0" />
        <CommunityPostInput
          post={post}
          onCancel={() => setOpen(false)}
          onSuccess={() => setOpen(false)}
        />
      </div>
    </ColumnModal>
  );
};
